import React, { memo } from 'react';
import { Flex } from 'onefaceui-react-components';

import StatusCaption from 'react/components/StatusCaption';
import { getResourceTo } from 'react/utils/utils';
import { getStopStatusResourceByStatus } from 'react/utils/stopUtils';

function StopStatusCaption() {
  const toggleLabel = getResourceTo('kpi.stopsstatus');
  const status = [
    'pending',
    'delivered',
    'partially_delivered',
    'redelivered',
    'undelivered',
    'canceled',
    'in_progress'
  ];

  const options = status.map((key) => ({
    type: key,
    title: getResourceTo(getStopStatusResourceByStatus(key)),
    captionItemLabelClassname: `${key}-icon`
  }));

  return (
    <Flex className="caption-info caption-stop" alignItems="center" gap={16}>
      <StatusCaption toggleLabel={toggleLabel} options={options} />
    </Flex>
  );
}

export default memo(StopStatusCaption);
